import React, { useState } from "react";
import { Box } from "@mui/material";
import Sidebar, { COLLAPSED_DRAWER_WIDTH } from "./Sidebar";
import TopBar from "./TopBar";
import ProtectedRoute from "./ProtectedRoute";
import WorkspaceSeo from "./WorkspaceSeo";

const AppLayout = ({ children }) => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <ProtectedRoute>
      <WorkspaceSeo />
      <Box sx={{ display: "flex" }}>
        <Sidebar open={mobileOpen} onClose={handleDrawerToggle} />
        <TopBar onMenuClick={handleDrawerToggle} />

        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            bgcolor: "background.default",
            width: {
              md: `calc(100% - ${COLLAPSED_DRAWER_WIDTH}px)`,
            },
            ml: {
              md: `${COLLAPSED_DRAWER_WIDTH}px`,
            },
            mt: { xs: 8, md: 0 },
            minHeight: "100vh",
            overflow: "auto",
          }}
        >
          {children}
        </Box>
      </Box>
    </ProtectedRoute>
  );
};

export default AppLayout;
